import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';

config({
  licenseKey,
  defaultCurrency: 'EUR',
  forceIsoDateParsing: false,
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch(err => console.error(err));
